import { connect } from 'react-redux';
import Alarms from './Alarms';
import { getData, getAndStore } from '../../actions/utils';
import activeAlarmsSchema from '../../normalizr-schemas/activeAlarmsSchema';
import completedAlarmsSchema from '../../normalizr-schemas/completedAlarmsSchema';

const mapStateToProps = ({ activeAlarms, completedAlarms }) => ({
  activeAlarms,
  completedAlarms,
});

const mapDispatchToProps = dispatch => ({
  getAlarms: (status) => {
    let params = {};
    let reducerName = '';
    let withCursor;
    let schema;
    if (status === 'active') {
      params = { status: 'active' };
      withCursor = false;
      reducerName = 'activeAlarms';
      schema = activeAlarmsSchema;
    } else {
      params = { status: 'completed', limit: 10 };
      withCursor = true;
      reducerName = 'completedAlarms';
      schema = completedAlarmsSchema;
    }
    return dispatch(getData(reducerName, 'alarms', schema, withCursor, params));
  },
  loadMore: () => dispatch(getAndStore('completedAlarms', 'alarms', completedAlarmsSchema, true, { status: 'completed', limit: 10 })),
});

const AlarmsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Alarms);

export default AlarmsContainer;



// WEBPACK FOOTER //
// ./src/components/Alarms/AlarmsContainer.js